module.exports = __webpack_public_path__ + "media/images/ic-index-text-3f239b36b833cfd65964ccdbc0247eb5.svg";